import _objectSpread from "/builds/zappy-ride/client-burbank-ev/frontend/application/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import ur from "react";

function Ar(u) {
  return u && u.__esModule && Object.prototype.hasOwnProperty.call(u, "default") ? u.default : u;
}

var ke = {
  exports: {}
},
    he = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var Ke;

function Ir() {
  return Ke || (Ke = 1, process.env.NODE_ENV !== "production" && function () {
    var u = ur,
        D = Symbol.for("react.element"),
        I = Symbol.for("react.portal"),
        d = Symbol.for("react.fragment"),
        w = Symbol.for("react.strict_mode"),
        f = Symbol.for("react.profiler"),
        O = Symbol.for("react.provider"),
        c = Symbol.for("react.context"),
        p = Symbol.for("react.forward_ref"),
        P = Symbol.for("react.suspense"),
        l = Symbol.for("react.suspense_list"),
        g = Symbol.for("react.memo"),
        $ = Symbol.for("react.lazy"),
        F = Symbol.for("react.offscreen"),
        z = Symbol.iterator,
        M = "@@iterator";

    function V(e) {
      if (e === null || typeof e != "object") return null;
      var r = z && e[z] || e[M];
      return typeof r == "function" ? r : null;
    }

    var U = u.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

    function Y(e) {
      {
        for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), s = 1; s < r; s++) {
          n[s - 1] = arguments[s];
        }

        N("error", e, n);
      }
    }

    function N(e, r, n) {
      {
        var s = U.ReactDebugCurrentFrame,
            x = s.getStackAddendum();
        x !== "" && (r += "%s", n = n.concat([x]));
        var k = n.map(function (S) {
          return String(S);
        });
        k.unshift("Warning: " + r), Function.prototype.apply.call(console[e], console, k);
      }
    }

    var q = !1,
        o = !1,
        ee = !1,
        ve = !1,
        pe = !1,
        ie;
    ie = Symbol.for("react.module.reference");

    function ye(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === d || e === f || pe || e === w || e === P || e === l || ve || e === F || q || o || ee || typeof e == "object" && e !== null && (e.$$typeof === $ || e.$$typeof === g || e.$$typeof === O || e.$$typeof === c || e.$$typeof === p || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === ie || e.getModuleId !== void 0));
    }

    function ue(e, r, n) {
      var s = e.displayName;
      if (s) return s;
      var x = r.displayName || r.name || "";
      return x !== "" ? n + "(" + x + ")" : n;
    }

    function se(e) {
      return e.displayName || "Context";
    }

    function H(e) {
      if (e == null) return null;
      if (typeof e.tag == "number" && Y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function") return e.displayName || e.name || null;
      if (typeof e == "string") return e;

      switch (e) {
        case d:
          return "Fragment";

        case I:
          return "Portal";

        case f:
          return "Profiler";

        case w:
          return "StrictMode";

        case P:
          return "Suspense";

        case l:
          return "SuspenseList";
      }

      if (typeof e == "object") switch (e.$$typeof) {
        case c:
          var r = e;
          return se(r) + ".Consumer";

        case O:
          var n = e;
          return se(n._context) + ".Provider";

        case p:
          return ue(e, e.render, "ForwardRef");

        case g:
          var s = e.displayName || null;
          return s !== null ? s : H(e.type) || "Memo";

        case $:
          {
            var x = e,
                k = x._payload,
                S = x._init;

            try {
              return H(S(k));
            } catch (_unused) {
              return null;
            }
          }
      }
      return null;
    }

    var G = Object.assign,
        re = 0,
        K,
        Q,
        ne,
        fe,
        t,
        i,
        m;

    function h() {}

    h.__reactDisabledLog = !0;

    function v() {
      {
        if (re === 0) {
          K = console.log, Q = console.info, ne = console.warn, fe = console.error, t = console.group, i = console.groupCollapsed, m = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: h,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }

        re++;
      }
    }

    function R() {
      {
        if (re--, re === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: G({}, e, {
              value: K
            }),
            info: G({}, e, {
              value: Q
            }),
            warn: G({}, e, {
              value: ne
            }),
            error: G({}, e, {
              value: fe
            }),
            group: G({}, e, {
              value: t
            }),
            groupCollapsed: G({}, e, {
              value: i
            }),
            groupEnd: G({}, e, {
              value: m
            })
          });
        }

        re < 0 && Y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }

    var y = U.ReactCurrentDispatcher,
        b;

    function E(e, r, n) {
      {
        if (b === void 0) try {
          throw Error();
        } catch (x) {
          var s = x.stack.trim().match(/\n( *(at )?)/);
          b = s && s[1] || "";
        }
        return "\n" + b + e;
      }
    }

    var C = !1,
        T;
    {
      var B = typeof WeakMap == "function" ? WeakMap : Map;
      T = new B();
    }

    function a(e, r) {
      if (!e || C) return "";
      {
        var n = T.get(e);
        if (n !== void 0) return n;
      }
      var s;
      C = !0;
      var x = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var k;
      k = y.current, y.current = null, v();

      try {
        if (r) {
          var S = function S() {
            throw Error();
          };

          if (Object.defineProperty(S.prototype, "props", {
            set: function set() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (te) {
              s = te;
            }

            Reflect.construct(e, [], S);
          } else {
            try {
              S.call();
            } catch (te) {
              s = te;
            }

            e.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            s = te;
          }

          e();
        }
      } catch (te) {
        if (te && s && typeof te.stack == "string") {
          for (var _ = te.stack.split("\n"), J = s.stack.split("\n"), W = _.length - 1, L = J.length - 1; W >= 1 && L >= 0 && _[W] !== J[L];) {
            L--;
          }

          for (; W >= 1 && L >= 0; W--, L--) {
            if (_[W] !== J[L]) {
              if (W !== 1 || L !== 1) do {
                if (W--, L--, L < 0 || _[W] !== J[L]) {
                  var Z = "\n" + _[W].replace(" at new ", " at ");

                  return e.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", e.displayName)), typeof e == "function" && T.set(e, Z), Z;
                }
              } while (W >= 1 && L >= 0);
              break;
            }
          }
        }
      } finally {
        C = !1, y.current = k, R(), Error.prepareStackTrace = x;
      }

      var de = e ? e.displayName || e.name : "",
          He = de ? E(de) : "";
      return typeof e == "function" && T.set(e, He), He;
    }

    function X(e, r, n) {
      return a(e, !1);
    }

    function ce(e) {
      var r = e.prototype;
      return !!(r && r.isReactComponent);
    }

    function ae(e, r, n) {
      if (e == null) return "";
      if (typeof e == "function") return a(e, ce(e));
      if (typeof e == "string") return E(e);

      switch (e) {
        case P:
          return E("Suspense");

        case l:
          return E("SuspenseList");
      }

      if (typeof e == "object") switch (e.$$typeof) {
        case p:
          return X(e.render);

        case g:
          return ae(e.type, r, n);

        case $:
          {
            var s = e,
                x = s._payload,
                k = s._init;

            try {
              return ae(k(x), r, n);
            } catch (_unused2) {}
          }
      }
      return "";
    }

    var ge = Object.prototype.hasOwnProperty,
        Fe = {},
        Ye = U.ReactDebugCurrentFrame;

    function Ee(e) {
      if (e) {
        var r = e._owner,
            n = ae(e.type, e._source, r ? r.type : null);
        Ye.setExtraStackFrame(n);
      } else Ye.setExtraStackFrame(null);
    }

    function lr(e, r, n, s, x) {
      {
        var k = Function.call.bind(ge);

        for (var S in e) {
          if (k(e, S)) {
            var _ = void 0;

            try {
              if (typeof e[S] != "function") {
                var J = Error((s || "React class") + ": " + n + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw J.name = "Invariant Violation", J;
              }

              _ = e[S](r, S, s, n, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (W) {
              _ = W;
            }

            _ && !(_ instanceof Error) && (Ee(x), Y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", s || "React class", n, S, typeof _), Ee(null)), _ instanceof Error && !(_.message in Fe) && (Fe[_.message] = !0, Ee(x), Y("Failed %s type: %s", n, _.message), Ee(null));
          }
        }
      }
    }

    var dr = Array.isArray;

    function _e(e) {
      return dr(e);
    }

    function vr(e) {
      {
        var r = typeof Symbol == "function" && Symbol.toStringTag,
            n = r && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return n;
      }
    }

    function pr(e) {
      try {
        return We(e), !1;
      } catch (_unused3) {
        return !0;
      }
    }

    function We(e) {
      return "" + e;
    }

    function qe(e) {
      if (pr(e)) return Y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", vr(e)), We(e);
    }

    var be = U.ReactCurrentOwner,
        yr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    },
        Le,
        Ue,
        Re;
    Re = {};

    function br(e) {
      if (ge.call(e, "ref")) {
        var r = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (r && r.isReactWarning) return !1;
      }

      return e.ref !== void 0;
    }

    function hr(e) {
      if (ge.call(e, "key")) {
        var r = Object.getOwnPropertyDescriptor(e, "key").get;
        if (r && r.isReactWarning) return !1;
      }

      return e.key !== void 0;
    }

    function mr(e, r) {
      if (typeof e.ref == "string" && be.current && r && be.current.stateNode !== r) {
        var n = H(be.current.type);
        Re[n] || (Y('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', H(be.current.type), e.ref), Re[n] = !0);
      }
    }

    function gr(e, r) {
      {
        var n = function n() {
          Le || (Le = !0, Y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };

        n.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: n,
          configurable: !0
        });
      }
    }

    function Er(e, r) {
      {
        var n = function n() {
          Ue || (Ue = !0, Y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };

        n.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: n,
          configurable: !0
        });
      }
    }

    var Tr = function Tr(e, r, n, s, x, k, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: D,
        // Built-in properties that belong on the element
        type: e,
        key: r,
        ref: n,
        props: S,
        // Record the component responsible for creating this element.
        _owner: k
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: s
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: x
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };

    function _r(e, r, n, s, x) {
      {
        var k,
            S = {},
            _ = null,
            J = null;
        n !== void 0 && (qe(n), _ = "" + n), hr(r) && (qe(r.key), _ = "" + r.key), br(r) && (J = r.ref, mr(r, x));

        for (k in r) {
          ge.call(r, k) && !yr.hasOwnProperty(k) && (S[k] = r[k]);
        }

        if (e && e.defaultProps) {
          var W = e.defaultProps;

          for (k in W) {
            S[k] === void 0 && (S[k] = W[k]);
          }
        }

        if (_ || J) {
          var L = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          _ && gr(S, L), J && Er(S, L);
        }

        return Tr(e, _, J, x, s, be.current, S);
      }
    }

    var Se = U.ReactCurrentOwner,
        Ne = U.ReactDebugCurrentFrame;

    function le(e) {
      if (e) {
        var r = e._owner,
            n = ae(e.type, e._source, r ? r.type : null);
        Ne.setExtraStackFrame(n);
      } else Ne.setExtraStackFrame(null);
    }

    var Oe;
    Oe = !1;

    function Pe(e) {
      return typeof e == "object" && e !== null && e.$$typeof === D;
    }

    function Ve() {
      {
        if (Se.current) {
          var e = H(Se.current.type);
          if (e) return "\n\nCheck the render method of `" + e + "`.";
        }

        return "";
      }
    }

    function Rr(e) {
      {
        if (e !== void 0) {
          var r = e.fileName.replace(/^.*[\\\/]/, ""),
              n = e.lineNumber;
          return "\n\nCheck your code at " + r + ":" + n + ".";
        }

        return "";
      }
    }

    var ze = {};

    function Sr(e) {
      {
        var r = Ve();

        if (!r) {
          var n = typeof e == "string" ? e : e.displayName || e.name;
          n && (r = "\n\nCheck the top-level render call using <" + n + ">.");
        }

        return r;
      }
    }

    function Be(e, r) {
      {
        if (!e._store || e._store.validated || e.key != null) return;
        e._store.validated = !0;
        var n = Sr(r);
        if (ze[n]) return;
        ze[n] = !0;
        var s = "";
        e && e._owner && e._owner !== Se.current && (s = " It was passed a child from " + H(e._owner.type) + "."), le(e), Y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', n, s), le(null);
      }
    }

    function Je(e, r) {
      {
        if (typeof e != "object") return;
        if (_e(e)) for (var n = 0; n < e.length; n++) {
          var s = e[n];
          Pe(s) && Be(s, r);
        } else if (Pe(e)) e._store && (e._store.validated = !0);else if (e) {
          var x = V(e);
          if (typeof x == "function" && x !== e.entries) for (var k = x.call(e), S; !(S = k.next()).done;) {
            Pe(S.value) && Be(S.value, r);
          }
        }
      }
    }

    function Or(e) {
      {
        var r = e.type;
        if (r == null || typeof r == "string") return;
        var n;
        if (typeof r == "function") n = r.propTypes;else if (typeof r == "object" && (r.$$typeof === p || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        r.$$typeof === g)) n = r.propTypes;else return;

        if (n) {
          var s = H(r);
          lr(n, e.props, "prop", s, e);
        } else if (r.PropTypes !== void 0 && !Oe) {
          Oe = !0;
          var x = H(r);
          Y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", x || "Unknown");
        }

        typeof r.getDefaultProps == "function" && !r.getDefaultProps.isReactClassApproved && Y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }

    function Pr(e) {
      {
        for (var r = Object.keys(e.props), n = 0; n < r.length; n++) {
          var s = r[n];

          if (s !== "children" && s !== "key") {
            le(e), Y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", s), le(null);
            break;
          }
        }

        e.ref !== null && (le(e), Y("Invalid attribute `ref` supplied to `React.Fragment`."), le(null));
      }
    }

    function Ge(e, r, n, s, x, k) {
      {
        var S = ye(e);

        if (!S) {
          var _ = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var J = Rr(x);
          J ? _ += J : _ += Ve();
          var W;
          e === null ? W = "null" : _e(e) ? W = "array" : e !== void 0 && e.$$typeof === D ? (W = "<" + (H(e.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : W = typeof e, Y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", W, _);
        }

        var L = _r(e, r, n, x, k);

        if (L == null) return L;

        if (S) {
          var Z = r.children;
          if (Z !== void 0) if (s) {
            if (_e(Z)) {
              for (var de = 0; de < Z.length; de++) {
                Je(Z[de], e);
              }

              Object.freeze && Object.freeze(Z);
            } else Y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
          } else Je(Z, e);
        }

        return e === d ? Pr(L) : Or(L), L;
      }
    }

    function Cr(e, r, n) {
      return Ge(e, r, n, !0);
    }

    function wr(e, r, n) {
      return Ge(e, r, n, !1);
    }

    var xr = wr,
        jr = Cr;
    he.Fragment = d, he.jsx = xr, he.jsxs = jr;
  }()), he;
}

var me = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var Xe;

function $r() {
  if (Xe) return me;
  Xe = 1;
  var u = ur,
      D = Symbol.for("react.element"),
      I = Symbol.for("react.fragment"),
      d = Object.prototype.hasOwnProperty,
      w = u.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
      f = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
  };

  function O(c, p, P) {
    var l,
        g = {},
        $ = null,
        F = null;
    P !== void 0 && ($ = "" + P), p.key !== void 0 && ($ = "" + p.key), p.ref !== void 0 && (F = p.ref);

    for (l in p) {
      d.call(p, l) && !f.hasOwnProperty(l) && (g[l] = p[l]);
    }

    if (c && c.defaultProps) for (l in p = c.defaultProps, p) {
      g[l] === void 0 && (g[l] = p[l]);
    }
    return {
      $$typeof: D,
      type: c,
      key: $,
      ref: F,
      props: g,
      _owner: w.current
    };
  }

  return me.Fragment = I, me.jsx = O, me.jsxs = O, me;
}

process.env.NODE_ENV === "production" ? ke.exports = $r() : ke.exports = Ir();
var Ce = ke.exports,
    De = {
  exports: {}
},
    we,
    Ze;

function Me() {
  if (Ze) return we;
  Ze = 1;
  var u = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return we = u, we;
}

var xe, Qe;

function kr() {
  if (Qe) return xe;
  Qe = 1;
  var u = Me();

  function D() {}

  function I() {}

  return I.resetWarningCache = D, xe = function xe() {
    function d(O, c, p, P, l, g) {
      if (g !== u) {
        var $ = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw $.name = "Invariant Violation", $;
      }
    }

    d.isRequired = d;

    function w() {
      return d;
    }

    var f = {
      array: d,
      bigint: d,
      bool: d,
      func: d,
      number: d,
      object: d,
      string: d,
      symbol: d,
      any: d,
      arrayOf: w,
      element: d,
      elementType: d,
      instanceOf: w,
      node: d,
      objectOf: w,
      oneOf: w,
      oneOfType: w,
      shape: w,
      exact: w,
      checkPropTypes: I,
      resetWarningCache: D
    };
    return f.PropTypes = f, f;
  }, xe;
}

var Te = {
  exports: {}
},
    j = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var er;

function Dr() {
  return er || (er = 1, process.env.NODE_ENV !== "production" && function () {
    var u = typeof Symbol == "function" && Symbol.for,
        D = u ? Symbol.for("react.element") : 60103,
        I = u ? Symbol.for("react.portal") : 60106,
        d = u ? Symbol.for("react.fragment") : 60107,
        w = u ? Symbol.for("react.strict_mode") : 60108,
        f = u ? Symbol.for("react.profiler") : 60114,
        O = u ? Symbol.for("react.provider") : 60109,
        c = u ? Symbol.for("react.context") : 60110,
        p = u ? Symbol.for("react.async_mode") : 60111,
        P = u ? Symbol.for("react.concurrent_mode") : 60111,
        l = u ? Symbol.for("react.forward_ref") : 60112,
        g = u ? Symbol.for("react.suspense") : 60113,
        $ = u ? Symbol.for("react.suspense_list") : 60120,
        F = u ? Symbol.for("react.memo") : 60115,
        z = u ? Symbol.for("react.lazy") : 60116,
        M = u ? Symbol.for("react.block") : 60121,
        V = u ? Symbol.for("react.fundamental") : 60117,
        U = u ? Symbol.for("react.responder") : 60118,
        Y = u ? Symbol.for("react.scope") : 60119;

    function N(a) {
      return typeof a == "string" || typeof a == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      a === d || a === P || a === f || a === w || a === g || a === $ || typeof a == "object" && a !== null && (a.$$typeof === z || a.$$typeof === F || a.$$typeof === O || a.$$typeof === c || a.$$typeof === l || a.$$typeof === V || a.$$typeof === U || a.$$typeof === Y || a.$$typeof === M);
    }

    function q(a) {
      if (typeof a == "object" && a !== null) {
        var X = a.$$typeof;

        switch (X) {
          case D:
            var ce = a.type;

            switch (ce) {
              case p:
              case P:
              case d:
              case f:
              case w:
              case g:
                return ce;

              default:
                var ae = ce && ce.$$typeof;

                switch (ae) {
                  case c:
                  case l:
                  case z:
                  case F:
                  case O:
                    return ae;

                  default:
                    return X;
                }

            }

          case I:
            return X;
        }
      }
    }

    var o = p,
        ee = P,
        ve = c,
        pe = O,
        ie = D,
        ye = l,
        ue = d,
        se = z,
        H = F,
        G = I,
        re = f,
        K = w,
        Q = g,
        ne = !1;

    function fe(a) {
      return ne || (ne = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), t(a) || q(a) === p;
    }

    function t(a) {
      return q(a) === P;
    }

    function i(a) {
      return q(a) === c;
    }

    function m(a) {
      return q(a) === O;
    }

    function h(a) {
      return typeof a == "object" && a !== null && a.$$typeof === D;
    }

    function v(a) {
      return q(a) === l;
    }

    function R(a) {
      return q(a) === d;
    }

    function y(a) {
      return q(a) === z;
    }

    function b(a) {
      return q(a) === F;
    }

    function E(a) {
      return q(a) === I;
    }

    function C(a) {
      return q(a) === f;
    }

    function T(a) {
      return q(a) === w;
    }

    function B(a) {
      return q(a) === g;
    }

    j.AsyncMode = o, j.ConcurrentMode = ee, j.ContextConsumer = ve, j.ContextProvider = pe, j.Element = ie, j.ForwardRef = ye, j.Fragment = ue, j.Lazy = se, j.Memo = H, j.Portal = G, j.Profiler = re, j.StrictMode = K, j.Suspense = Q, j.isAsyncMode = fe, j.isConcurrentMode = t, j.isContextConsumer = i, j.isContextProvider = m, j.isElement = h, j.isForwardRef = v, j.isFragment = R, j.isLazy = y, j.isMemo = b, j.isPortal = E, j.isProfiler = C, j.isStrictMode = T, j.isSuspense = B, j.isValidElementType = N, j.typeOf = q;
  }()), j;
}

var A = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var rr;

function Mr() {
  if (rr) return A;
  rr = 1;
  var u = typeof Symbol == "function" && Symbol.for,
      D = u ? Symbol.for("react.element") : 60103,
      I = u ? Symbol.for("react.portal") : 60106,
      d = u ? Symbol.for("react.fragment") : 60107,
      w = u ? Symbol.for("react.strict_mode") : 60108,
      f = u ? Symbol.for("react.profiler") : 60114,
      O = u ? Symbol.for("react.provider") : 60109,
      c = u ? Symbol.for("react.context") : 60110,
      p = u ? Symbol.for("react.async_mode") : 60111,
      P = u ? Symbol.for("react.concurrent_mode") : 60111,
      l = u ? Symbol.for("react.forward_ref") : 60112,
      g = u ? Symbol.for("react.suspense") : 60113,
      $ = u ? Symbol.for("react.suspense_list") : 60120,
      F = u ? Symbol.for("react.memo") : 60115,
      z = u ? Symbol.for("react.lazy") : 60116,
      M = u ? Symbol.for("react.block") : 60121,
      V = u ? Symbol.for("react.fundamental") : 60117,
      U = u ? Symbol.for("react.responder") : 60118,
      Y = u ? Symbol.for("react.scope") : 60119;

  function N(o) {
    if (typeof o == "object" && o !== null) {
      var ee = o.$$typeof;

      switch (ee) {
        case D:
          switch (o = o.type, o) {
            case p:
            case P:
            case d:
            case f:
            case w:
            case g:
              return o;

            default:
              switch (o = o && o.$$typeof, o) {
                case c:
                case l:
                case z:
                case F:
                case O:
                  return o;

                default:
                  return ee;
              }

          }

        case I:
          return ee;
      }
    }
  }

  function q(o) {
    return N(o) === P;
  }

  return A.AsyncMode = p, A.ConcurrentMode = P, A.ContextConsumer = c, A.ContextProvider = O, A.Element = D, A.ForwardRef = l, A.Fragment = d, A.Lazy = z, A.Memo = F, A.Portal = I, A.Profiler = f, A.StrictMode = w, A.Suspense = g, A.isAsyncMode = function (o) {
    return q(o) || N(o) === p;
  }, A.isConcurrentMode = q, A.isContextConsumer = function (o) {
    return N(o) === c;
  }, A.isContextProvider = function (o) {
    return N(o) === O;
  }, A.isElement = function (o) {
    return typeof o == "object" && o !== null && o.$$typeof === D;
  }, A.isForwardRef = function (o) {
    return N(o) === l;
  }, A.isFragment = function (o) {
    return N(o) === d;
  }, A.isLazy = function (o) {
    return N(o) === z;
  }, A.isMemo = function (o) {
    return N(o) === F;
  }, A.isPortal = function (o) {
    return N(o) === I;
  }, A.isProfiler = function (o) {
    return N(o) === f;
  }, A.isStrictMode = function (o) {
    return N(o) === w;
  }, A.isSuspense = function (o) {
    return N(o) === g;
  }, A.isValidElementType = function (o) {
    return typeof o == "string" || typeof o == "function" || o === d || o === P || o === f || o === w || o === g || o === $ || typeof o == "object" && o !== null && (o.$$typeof === z || o.$$typeof === F || o.$$typeof === O || o.$$typeof === c || o.$$typeof === l || o.$$typeof === V || o.$$typeof === U || o.$$typeof === Y || o.$$typeof === M);
  }, A.typeOf = N, A;
}

var tr;

function sr() {
  return tr || (tr = 1, process.env.NODE_ENV === "production" ? Te.exports = Mr() : Te.exports = Dr()), Te.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


var je, nr;

function Fr() {
  if (nr) return je;
  nr = 1;
  var u = Object.getOwnPropertySymbols,
      D = Object.prototype.hasOwnProperty,
      I = Object.prototype.propertyIsEnumerable;

  function d(f) {
    if (f == null) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(f);
  }

  function w() {
    try {
      if (!Object.assign) return !1;
      var f = new String("abc");
      if (f[5] = "de", Object.getOwnPropertyNames(f)[0] === "5") return !1;

      for (var O = {}, c = 0; c < 10; c++) {
        O["_" + String.fromCharCode(c)] = c;
      }

      var p = Object.getOwnPropertyNames(O).map(function (l) {
        return O[l];
      });
      if (p.join("") !== "0123456789") return !1;
      var P = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (l) {
        P[l] = l;
      }), Object.keys(Object.assign({}, P)).join("") === "abcdefghijklmnopqrst";
    } catch (_unused4) {
      return !1;
    }
  }

  return je = w() ? Object.assign : function (f, O) {
    for (var c, p = d(f), P, l = 1; l < arguments.length; l++) {
      c = Object(arguments[l]);

      for (var g in c) {
        D.call(c, g) && (p[g] = c[g]);
      }

      if (u) {
        P = u(c);

        for (var $ = 0; $ < P.length; $++) {
          I.call(c, P[$]) && (p[P[$]] = c[P[$]]);
        }
      }
    }

    return p;
  }, je;
}

var Ae, ar;

function fr() {
  return ar || (ar = 1, Ae = Function.call.bind(Object.prototype.hasOwnProperty)), Ae;
}

var Ie, or;

function Yr() {
  if (or) return Ie;
  or = 1;

  var u = function u() {};

  if (process.env.NODE_ENV !== "production") {
    var D = Me(),
        I = {},
        d = fr();

    u = function u(f) {
      var O = "Warning: " + f;
      typeof console < "u" && console.error(O);

      try {
        throw new Error(O);
      } catch (_unused5) {}
    };
  }

  function w(f, O, c, p, P) {
    if (process.env.NODE_ENV !== "production") {
      for (var l in f) {
        if (d(f, l)) {
          var g;

          try {
            if (typeof f[l] != "function") {
              var $ = Error((p || "React class") + ": " + c + " type `" + l + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof f[l] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
              throw $.name = "Invariant Violation", $;
            }

            g = f[l](O, l, p, c, null, D);
          } catch (z) {
            g = z;
          }

          if (g && !(g instanceof Error) && u((p || "React class") + ": type specification of " + c + " `" + l + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof g + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), g instanceof Error && !(g.message in I)) {
            var _F;

            I[g.message] = !0;
            var F = P ? P() : "";
            u("Failed " + c + " type: " + g.message + ((_F = F) !== null && _F !== void 0 ? _F : ""));
          }
        }
      }
    }
  }

  return w.resetWarningCache = function () {
    process.env.NODE_ENV !== "production" && (I = {});
  }, Ie = w, Ie;
}

var $e, ir;

function Wr() {
  if (ir) return $e;
  ir = 1;

  var u = sr(),
      D = Fr(),
      I = Me(),
      d = fr(),
      w = Yr(),
      f = function f() {};

  process.env.NODE_ENV !== "production" && (f = function f(c) {
    var p = "Warning: " + c;
    typeof console < "u" && console.error(p);

    try {
      throw new Error(p);
    } catch (_unused6) {}
  });

  function O() {
    return null;
  }

  return $e = function $e(c, p) {
    var P = typeof Symbol == "function" && Symbol.iterator,
        l = "@@iterator";

    function g(t) {
      var i = t && (P && t[P] || t[l]);
      if (typeof i == "function") return i;
    }

    var $ = "<<anonymous>>",
        F = {
      array: U("array"),
      bigint: U("bigint"),
      bool: U("boolean"),
      func: U("function"),
      number: U("number"),
      object: U("object"),
      string: U("string"),
      symbol: U("symbol"),
      any: Y(),
      arrayOf: N,
      element: q(),
      elementType: o(),
      instanceOf: ee,
      node: ye(),
      objectOf: pe,
      oneOf: ve,
      oneOfType: ie,
      shape: se,
      exact: H
    };

    function z(t, i) {
      return t === i ? t !== 0 || 1 / t === 1 / i : t !== t && i !== i;
    }

    function M(t, i) {
      this.message = t, this.data = i && typeof i == "object" ? i : {}, this.stack = "";
    }

    M.prototype = Error.prototype;

    function V(t) {
      if (process.env.NODE_ENV !== "production") var i = {},
          m = 0;

      function h(R, y, b, E, C, T, B) {
        if (E = E || $, T = T || b, B !== I) {
          if (p) {
            var a = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
            throw a.name = "Invariant Violation", a;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var X = E + ":" + b;
            !i[X] && // Avoid spamming the console because they are often not actionable except for lib authors
            m < 3 && (f("You are manually calling a React.PropTypes validation function for the `" + T + "` prop on `" + E + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), i[X] = !0, m++);
          }
        }

        return y[b] == null ? R ? y[b] === null ? new M("The " + C + " `" + T + "` is marked as required " + ("in `" + E + "`, but its value is `null`.")) : new M("The " + C + " `" + T + "` is marked as required in " + ("`" + E + "`, but its value is `undefined`.")) : null : t(y, b, E, C, T);
      }

      var v = h.bind(null, !1);
      return v.isRequired = h.bind(null, !0), v;
    }

    function U(t) {
      function i(m, h, v, R, y, b) {
        var E = m[h],
            C = K(E);

        if (C !== t) {
          var T = Q(E);
          return new M("Invalid " + R + " `" + y + "` of type " + ("`" + T + "` supplied to `" + v + "`, expected ") + ("`" + t + "`."), {
            expectedType: t
          });
        }

        return null;
      }

      return V(i);
    }

    function Y() {
      return V(O);
    }

    function N(t) {
      function i(m, h, v, R, y) {
        if (typeof t != "function") return new M("Property `" + y + "` of component `" + v + "` has invalid PropType notation inside arrayOf.");
        var b = m[h];

        if (!Array.isArray(b)) {
          var E = K(b);
          return new M("Invalid " + R + " `" + y + "` of type " + ("`" + E + "` supplied to `" + v + "`, expected an array."));
        }

        for (var C = 0; C < b.length; C++) {
          var T = t(b, C, v, R, y + "[" + C + "]", I);
          if (T instanceof Error) return T;
        }

        return null;
      }

      return V(i);
    }

    function q() {
      function t(i, m, h, v, R) {
        var y = i[m];

        if (!c(y)) {
          var b = K(y);
          return new M("Invalid " + v + " `" + R + "` of type " + ("`" + b + "` supplied to `" + h + "`, expected a single ReactElement."));
        }

        return null;
      }

      return V(t);
    }

    function o() {
      function t(i, m, h, v, R) {
        var y = i[m];

        if (!u.isValidElementType(y)) {
          var b = K(y);
          return new M("Invalid " + v + " `" + R + "` of type " + ("`" + b + "` supplied to `" + h + "`, expected a single ReactElement type."));
        }

        return null;
      }

      return V(t);
    }

    function ee(t) {
      function i(m, h, v, R, y) {
        if (!(m[h] instanceof t)) {
          var b = t.name || $,
              E = fe(m[h]);
          return new M("Invalid " + R + " `" + y + "` of type " + ("`" + E + "` supplied to `" + v + "`, expected ") + ("instance of `" + b + "`."));
        }

        return null;
      }

      return V(i);
    }

    function ve(t) {
      if (!Array.isArray(t)) return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? f("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).") : f("Invalid argument supplied to oneOf, expected an array.")), O;

      function i(m, h, v, R, y) {
        for (var b = m[h], E = 0; E < t.length; E++) {
          if (z(b, t[E])) return null;
        }

        var C = JSON.stringify(t, function (B, a) {
          var X = Q(a);
          return X === "symbol" ? String(a) : a;
        });
        return new M("Invalid " + R + " `" + y + "` of value `" + String(b) + "` " + ("supplied to `" + v + "`, expected one of " + C + "."));
      }

      return V(i);
    }

    function pe(t) {
      function i(m, h, v, R, y) {
        if (typeof t != "function") return new M("Property `" + y + "` of component `" + v + "` has invalid PropType notation inside objectOf.");
        var b = m[h],
            E = K(b);
        if (E !== "object") return new M("Invalid " + R + " `" + y + "` of type " + ("`" + E + "` supplied to `" + v + "`, expected an object."));

        for (var C in b) {
          if (d(b, C)) {
            var T = t(b, C, v, R, y + "." + C, I);
            if (T instanceof Error) return T;
          }
        }

        return null;
      }

      return V(i);
    }

    function ie(t) {
      if (!Array.isArray(t)) return process.env.NODE_ENV !== "production" && f("Invalid argument supplied to oneOfType, expected an instance of array."), O;

      for (var i = 0; i < t.length; i++) {
        var m = t[i];
        if (typeof m != "function") return f("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + ne(m) + " at index " + i + "."), O;
      }

      function h(v, R, y, b, E) {
        for (var C = [], T = 0; T < t.length; T++) {
          var B = t[T],
              a = B(v, R, y, b, E, I);
          if (a == null) return null;
          a.data && d(a.data, "expectedType") && C.push(a.data.expectedType);
        }

        var X = C.length > 0 ? ", expected one of type [" + C.join(", ") + "]" : "";
        return new M("Invalid " + b + " `" + E + "` supplied to " + ("`" + y + "`" + X + "."));
      }

      return V(h);
    }

    function ye() {
      function t(i, m, h, v, R) {
        return G(i[m]) ? null : new M("Invalid " + v + " `" + R + "` supplied to " + ("`" + h + "`, expected a ReactNode."));
      }

      return V(t);
    }

    function ue(t, i, m, h, v) {
      return new M((t || "React class") + ": " + i + " type `" + m + "." + h + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + v + "`.");
    }

    function se(t) {
      function i(m, h, v, R, y) {
        var b = m[h],
            E = K(b);
        if (E !== "object") return new M("Invalid " + R + " `" + y + "` of type `" + E + "` " + ("supplied to `" + v + "`, expected `object`."));

        for (var C in t) {
          var T = t[C];
          if (typeof T != "function") return ue(v, R, y, C, Q(T));
          var B = T(b, C, v, R, y + "." + C, I);
          if (B) return B;
        }

        return null;
      }

      return V(i);
    }

    function H(t) {
      function i(m, h, v, R, y) {
        var b = m[h],
            E = K(b);
        if (E !== "object") return new M("Invalid " + R + " `" + y + "` of type `" + E + "` " + ("supplied to `" + v + "`, expected `object`."));
        var C = D({}, m[h], t);

        for (var T in C) {
          var B = t[T];
          if (d(t, T) && typeof B != "function") return ue(v, R, y, T, Q(B));
          if (!B) return new M("Invalid " + R + " `" + y + "` key `" + T + "` supplied to `" + v + "`.\nBad object: " + JSON.stringify(m[h], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(t), null, "  "));
          var a = B(b, T, v, R, y + "." + T, I);
          if (a) return a;
        }

        return null;
      }

      return V(i);
    }

    function G(t) {
      switch (typeof t) {
        case "number":
        case "string":
        case "undefined":
          return !0;

        case "boolean":
          return !t;

        case "object":
          if (Array.isArray(t)) return t.every(G);
          if (t === null || c(t)) return !0;
          var i = g(t);

          if (i) {
            var m = i.call(t),
                h;

            if (i !== t.entries) {
              for (; !(h = m.next()).done;) {
                if (!G(h.value)) return !1;
              }
            } else for (; !(h = m.next()).done;) {
              var v = h.value;
              if (v && !G(v[1])) return !1;
            }
          } else return !1;

          return !0;

        default:
          return !1;
      }
    }

    function re(t, i) {
      return t === "symbol" ? !0 : i ? i["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && i instanceof Symbol : !1;
    }

    function K(t) {
      var i = typeof t;
      return Array.isArray(t) ? "array" : t instanceof RegExp ? "object" : re(i, t) ? "symbol" : i;
    }

    function Q(t) {
      if (typeof t > "u" || t === null) return "" + t;
      var i = K(t);

      if (i === "object") {
        if (t instanceof Date) return "date";
        if (t instanceof RegExp) return "regexp";
      }

      return i;
    }

    function ne(t) {
      var i = Q(t);

      switch (i) {
        case "array":
        case "object":
          return "an " + i;

        case "boolean":
        case "date":
        case "regexp":
          return "a " + i;

        default:
          return i;
      }
    }

    function fe(t) {
      return !t.constructor || !t.constructor.name ? $ : t.constructor.name;
    }

    return F.checkPropTypes = w, F.resetWarningCache = w.resetWarningCache, F.PropTypes = F, F;
  }, $e;
}

if (process.env.NODE_ENV !== "production") {
  var qr = sr(),
      Lr = !0;
  De.exports = Wr()(qr.isElement, Lr);
} else De.exports = kr()();

var Ur = De.exports;

var oe = /* @__PURE__ */Ar(Ur),
    cr = function cr(_ref) {
  var u = _ref.clientName,
      D = _ref.font,
      I = _ref.backgroundColor,
      d = _ref.fontColor,
      w = _ref.wrapperStyle,
      f = _ref.imageStyle,
      O = _ref.textStyle;

  var c = "https://assets.zappyride.com/img/icons/".concat(u, "/zappyride.svg"),
      p = _objectSpread({
    fontFamily: D,
    backgroundColor: I,
    // background color for the entire component
    color: d,
    // font color for the text
    padding: "10px"
  }, w);

  return /* @__PURE__ */Ce.jsxs("div", {
    style: p,
    children: [/* @__PURE__ */Ce.jsx("img", {
      src: c,
      alt: "".concat(u, " logo"),
      style: f
    }), /* @__PURE__ */Ce.jsx("p", {
      style: O,
      children: "Figures shown on this page are estimates based on data provided by third-parties. This material is provided for informational purposes only and should not be relied on for tax, legal, or financial advice.  Neither ZappyRide® nor J.D. Power® provides tax, legal or financial advice. You should independently verify the estimates provided here before engaging in any transaction."
    })]
  });
};

cr.propTypes = {
  clientName: oe.string.isRequired,
  font: oe.string,
  backgroundColor: oe.string,
  fontColor: oe.string,
  wrapperStyle: oe.object,
  imageStyle: oe.object,
  textStyle: oe.object
};
cr.defaultProps = {
  clientName: "ZappyRide",
  font: "Arial",
  // Default font if none is provided
  backgroundColor: "#ffffff",
  // Default background color
  fontColor: "#000000" // Default font color

};
export { cr as default };